<mobile-page-part>

	<div class="info-content" style="min-width: 210px;">
		<department-selector [(selectedDepartmentId)]="departmentId"></department-selector>
	</div>

	<staff-list [staff]="staffMembers()"></staff-list>

</mobile-page-part>